"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
class APIDialog {
    constructor(dialogRef, data, fourD) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.curApi = data.apis[0];
    }
    ok(bypassPreview) {
        this.dialogRef.close({ api: this.curApi, model: this.data.model, datasetName: this.data.datasetName, bypassPreview: bypassPreview });
    }
    cancel() {
        this.dialogRef.close(false);
    }
    onClick(arg) {
        this.dialogRef.close(false);
    }
}
exports.APIDialog = APIDialog;
class EmptyDialog {
    constructor(dialogRef, data, fourD) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
    }
    onClick() {
        this.dialogRef.close(false);
    }
}
exports.EmptyDialog = EmptyDialog;
